import React, { useEffect, useState, useContext } from "react";
import { Context } from "../..";
import "./HoldModal.css"; // Assuming you have some CSS for styling

function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

const FINAL = randomIntFromInterval(90, 126);

const HoldModal = ({ setOpen, initialCount = 1, finalCount = FINAL }) => {
  const [count, setCount] = useState(initialCount);
  const [finished, setFinished] = useState(false);

  const {
    value: { localizationModule },
  } = useContext(Context);

  useEffect(() => {
    if (count < finalCount) {
      const interval = setInterval(() => {
        setCount((prevCount) => {
          if (prevCount < finalCount) {
            return Math.min(
              prevCount + randomIntFromInterval(1, 2),
              finalCount
            );
          } else {
            setFinished(true);
            clearInterval(interval);
            return prevCount;
          }
        });
      }, 5_300 / (finalCount - initialCount));
    }
  }, []);

  useEffect(() => {
    if (finished) {
      setTimeout(() => {
        setOpen && setOpen(false);
      }, 2_000);
    }
  }, [finished]);

  return (
    <div className="modal-overlay hold-modal">
      <div className="modal-content">
        <span className="loader"></span>
        <h1>{localizationModule.getText("holdTight")}</h1>
        <p>{localizationModule.getText("searchLenders")}</p>
        {/* <p className="hold-count">
          <span>
            {count}/{finalCount}
          </span>{" "}
          {localizationModule.getText("lendersChecked")}
        </p> */}
        {finished && (
          <p>
            {localizationModule.getText("lendersFound")}
            {/* <span className="hold-found">{randomIntFromInterval(1, 2)}</span> */}
          </p>
        )}
        <p></p>
      </div>
    </div>
  );
};

export default HoldModal;
